import React from "react";
import { Outlet } from "react-router-dom";

interface ErrorLayoutProps {
  // Add props here
}

const ErrorLayout: React.FC<ErrorLayoutProps> = () => {
  return (
    <div className="">
      <Outlet />
    </div>
  );
};

export default ErrorLayout;
